function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClear = function SvgClear(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10.278.5L11.5 1.722 1.722 11.5.5 10.278 10.278.5z",
    fill: props.fill
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 10.278L10.278 11.5.5 1.722 1.722.5l9.778 9.778z",
    fill: props.fill
  }));
};
export default SvgClear;